module.exports = __webpack_public_path__ + "static/media/07A.59c0551a.png";